

export default {
  // 页面标题
  title: '运踪配置管理',

  // 系统预置数据保护提示
  protection: {
    channelReadonly: 'CargoWare 渠道为系统预置渠道，禁止修改',
    businessReadonly: 'CargoWare 渠道下的 SE 业务为系统预置业务，禁止修改',
    nodeReadonly: 'CargoWare 渠道下 SE 业务的节点为系统预置节点，禁止修改',
    nodeCannotAdd: 'CargoWare 渠道下 SE 业务的节点为系统预置节点，禁止添加新节点',
    nodeCannotDelete: 'CargoWare 渠道下 SE 业务的节点为系统预置节点，禁止删除',
    nodeCannotReorder: 'CargoWare 渠道下 SE 业务的节点为系统预置节点，禁止调整顺序'
  },
  subtitle: '数据渠道配置',

  // 渠道相关
  channel: {
    title: '渠道管理',
    code: '渠道编码',
    nameCn: '渠道中文名称',
    nameEn: '渠道英文名称',
    type: '渠道类型',
    enable: '启用状态',
    add: '新增渠道',
    edit: '编辑渠道',
    view: '查看渠道',
    delete: '删除渠道',
    deleteConfirm: '确定要删除该渠道吗？删除后将级联删除所有关联的业务和节点数据，此操作不可恢复！',
    mainChannel: '主渠道',
    thirdPartyChannel: '第三方渠道',
    selectChannel: '请选择渠道',
    inputCode: '请输入渠道编码',
    inputNameCn: '请输入渠道中文名称',
    inputNameEn: '请输入渠道英文名称',
    codeRequired: '渠道编码不能为空',
    nameCnRequired: '渠道中文名称不能为空',
    typeRequired: '请选择渠道类型',
    codePattern: '渠道编码只能包含大写字母、数字和下划线',
    codeExists: '渠道编码已存在'
  },

  // 业务相关
  business: {
    title: '业务管理',
    code: '业务编码',
    nameCn: '业务中文名称',
    nameEn: '业务英文名称',
    enable: '启用状态',
    add: '新增业务',
    edit: '编辑业务',
    view: '查看业务',
    delete: '删除业务',
    deleteConfirm: '确定要删除该业务吗？删除后将级联删除所有关联的节点数据，此操作不可恢复！',
    selectBusiness: '请选择业务',
    inputCode: '请输入业务编码',
    inputNameCn: '请输入业务中文名称',
    inputNameEn: '请输入业务英文名称',
    codeRequired: '业务编码不能为空',
    nameCnRequired: '业务中文名称不能为空',
    codePattern: '业务编码只能包含大写字母、数字和下划线',
    codeExists: '业务编码已存在',
    seExport: '海运出口',
    seImport: '海运进口',
    aeExport: '空运出口',
    aeImport: '空运进口',
    noBusinessTip: '当前渠道暂无业务配置，请先添加业务'
  },

  // 节点相关
  node: {
    title: '节点管理',
    code: '节点编码',
    nameCn: '节点中文名称',
    nameEn: '节点英文名称',
    enable: '启用状态',
    externalDisplay: '外部展示',
    externalDisplayLabel: '外部客户展示',
    icon: '节点图标',
    sort: '排序号',
    add: '添加节点',
    edit: '编辑节点',
    view: '查看节点',
    delete: '删除节点',
    deleteConfirm: '确定要删除该节点吗？',
    reset: '重置节点',
    resetConfirm: '确定要重置所有节点配置吗？此操作将清空当前业务下的所有节点！',
    inputCode: '请输入节点编码',
    inputNameCn: '请输入节点中文名称',
    inputNameEn: '请输入节点英文名称',
    inputSort: '请输入排序号',
    codeRequired: '节点编码不能为空',
    nameCnRequired: '节点中文名称不能为空',
    codePattern: '节点编码只能包含大写字母、数字和下划线',
    sortPattern: '排序号必须是非负整数',
    uploadIcon: '上传图标',
    changeIcon: '更换图标',
    iconTip: '支持 JPG、PNG 格式，建议尺寸 128x128px，大小不超过 2MB',
    iconTypeError: '图标格式不正确，仅支持 JPG、PNG 格式',
    iconSizeError: '图标大小不能超过 2MB',
    dragTip: '拖拽节点可调整顺序',
    noNodeTip: '当前业务暂无节点配置，请添加节点',
    configTitle: '运踪节点配置',
    configInfo: '共 {count} 个节点 | 拖拽节点可调整顺序',
    stage: '阶段编码',
    stageNameCn: '阶段中文名称',
    inputStage: '请输入阶段编码（如 origin / transit / destination）',
    inputStageNameCn: '请输入阶段中文名称（如「起运地（出口）」）',
    stageTip: '同一 stage 编码的节点会被分到同一组渲染；中文名将作为分组标题。'
  },

  supplierInput: {
    sectionTitle: '供应商填写配置',
    enable: '启用供应商填写',
    template: '预设模板',
    templatePlaceholder: '请选择预设模板',
    applyTemplate: '应用模板',
    fieldTable: '字段配置',
    colField: '字段',
    colType: '类型',
    colRequired: '必填',
    colVisible: '显示',
    colAction: '操作',
    configure: '配置',
    locked: '锁定',
    fieldConfigTitle: '配置字段：{name}',
    resetDefault: '恢复默认',
    resetDone: '已恢复为默认配置',
    templateApplied: '模板已应用',
    templateLoadFail: '模板加载失败',
    lockedFieldTip: '该字段为系统核心字段，不可修改',
    needVisibleField: '启用供应商填写时，至少需要开启一个可配置字段的显示',
    fields: {
      status: '节点状态',
      exception_group: '异常信息',
      estimated_time: '预计时间',
      actual_time: '实际时间',
      estimated_remarks: '预计备注',
      actual_remarks: '实际备注',
      attachments: '附件'
    },
    fieldTypes: {
      status: '下拉选择',
      exception_group: '固定组合',
      datetime: '日期时间',
      text: '文本',
      file: '文件上传'
    },
    templates: {
      pickup: {
        name: '提货节点模板',
        desc: '适用于提货相关节点'
      },
      transit: {
        name: '运输节点模板',
        desc: '适用于运输途中节点'
      },
      customs: {
        name: '报关节点模板',
        desc: '适用于报关/清关节点'
      },
      port: {
        name: '口岸节点模板',
        desc: '适用于口岸相关节点'
      },
      delivery: {
        name: '签收节点模板',
        desc: '适用于签收相关节点'
      },
      common: {
        name: '通用节点模板',
        desc: '适用于其他节点的标准配置'
      }
    }
  },

  // 统计相关
  statistics: {
    totalNodes: '总节点数',
    enabledNodes: '已启用节点',
    disabledNodes: '已禁用节点',
    externalDisplayNodes: '外部展示节点'
  },

  // 操作按钮
  action: {
    import: '导入配置',
    export: '导出配置',
    save: '保存配置',
    editConfig: '编辑配置',
    cancelEdit: '取消编辑',
    cancel: '取消',
    confirm: '确定',
    reset: '重置',
    add: '新增',
    edit: '编辑',
    delete: '删除',
    view: '查看',
    close: '关闭',
    submit: '提交',
    back: '返回'
  },

  // 状态
  status: {
    enabled: '已启用',
    disabled: '已禁用',
    yes: '是',
    no: '否',
    externalShow: '外部展示',
    externalHide: '内部使用'
  },

  // 提示信息
  message: {
    saveSuccess: '保存成功',
    saveFail: '保存失败',
    saveFailRetry: '保存失败，请重试',
    networkError: '网络异常，请检查网络后重试',
    deleteSuccess: '删除成功',
    deleteFail: '删除失败',
    loadSuccess: '加载成功',
    loadFail: '加载失败',
    uploadSuccess: '上传成功',
    uploadFail: '上传失败',
    noData: '暂无数据',
    loading: '加载中...',
    saving: '保存中...',
    deleting: '删除中...',
    uploading: '上传中...',
    confirmSave: '确定要保存当前配置吗？',
    confirmCancelEdit: '确定要取消编辑吗？未保存的修改将丢失。',
    confirmDiscardNodeChanges: '确定放弃对节点的修改吗？',
    hasUnsavedChanges: '当前有未保存的修改，确定要离开吗？',
    selectChannelFirst: '请先选择渠道',
    selectBusinessFirst: '请先选择业务',
    pleaseEnterEditMode: '请先点击"编辑配置"按钮进入编辑模式',
    cancelSuccess: '已取消编辑',
    atLeastOneNode: '至少需要配置一个节点',
    atLeastOneBusiness: '至少需要配置一个业务',
    businessNeedsNodes: '业务"{name}"至少需要配置一个节点'
  },

  // 异常规则配置 SHOKZ-71
  exceptionRule: {
    tabTitle: '异常规则配置',
    nodeTabTitle: '运踪节点配置',
    addRule: '新增规则',
    enabledCount: '已启用',
    disabledCount: '已禁用',
    empty: '暂无异常规则',
    colCode: '规则编码',
    colName: '规则名称',
    colAlertLevel: '预警等级',
    alertLevelPlaceholder: '请选择预警等级',
    alertLevelRequired: '请选择预警等级',
    colDesc: '规则描述',
    colTriggerTimes: '触发时间点',
    colChannels: '通知渠道',
    colRecipients: '通知接收人',
    colStatus: '状态',
    colAction: '操作',
    statusEnabled: '启用',
    statusDisabled: '禁用',
    channelSystem: '系统',
    channelEmail: '邮件',
    channelDingtalk: '钉钉',
    levelNormal: '普通',
    levelImportant: '重要',
    levelUrgent: '紧急',
    deleteConfirm: '确定删除该规则吗？',
    presetCannotDelete: '预置规则不可删除，可禁用',
    enableSuccess: '已启用',
    disableSuccess: '已禁用',
    saveSuccess: '保存成功',
    deleteSuccess: '删除成功',
    runCheck: '手动检测',
    checkSuccess: '检测完成，本次触发 {count} 条预警',
    duplicateTimes: '触发时间点存在重复，请修改后再保存',
    duplicateLabel: '重复',
    editRuleTitle: '编辑异常规则',
    addRuleTitle: '新增异常规则',
    recipientOrderCreator: '订单创建人',
    recipientSales: '销售负责人',
    businessAF: '国际空运',
    businessOF: '国际海运',
    businessIE: '国际快递',
    businessDE: '国内快递',
    businessDL: '国内陆运',
    businessIL: '国际陆运',
    orderRangeTitle: '订单读取范围',
    orderRangeTip: '设置该业务类型需要监控的订单时间范围，避免扫描全量历史订单',
    orderRangePlaceholder: '未设置，将扫描全部订单',
    orderRangeTimeBase: '时间基准',
    orderRangeTimeBasePlaceholder: '请选择时间基准',
    orderRangeTimeBaseRequired: '请选择时间基准',
    timeBaseOrderTime: '下单时间',
    timeBaseCreateTime: '订单创建时间',
    timeBaseEtdTime: 'ETD 时间',
    orderRangeStart: '起始时间',
    orderRangeStartPlaceholder: '-30',
    orderRangeStartHint: '（负数为过去）',
    orderRangeEnd: '截止时间',
    orderRangeEndPlaceholder: '0',
    orderRangeEndHint: '（正数为未来）',
    orderRangeDayUnit: '天',
    orderRangeIncludeNoTime: '包含无时间订单',
    orderRangeSave: '保存配置',
    orderRangeReset: '重置',
    orderRangeResetConfirm: '确定重置为不限制时间范围吗？',
    orderRangeSaveSuccess: '订单读取范围配置已保存',
    orderRangeResetSuccess: '已重置为不限制时间范围',
    orderRangeSavedInvalid: '配置已保存，但时间范围无效，检测时将不会按此范围过滤',
    orderRangeInvalidWarning: '时间范围无效：起始时间不能晚于截止时间',
    orderRangeToday: '今天',
    orderRangePastDays: '过去 {days} 天',
    orderRangeFutureDays: '未来 {days} 天',
    orderRangeTo: '至',
    orderRangeFrom: '起',
    orderRangeWithin: '内'
  },

  alertPopup: {
    title: '运踪异常预警',
    waybillNo: '运单号',
    triggerTime: '触发时间',
    viewAll: '查看全部 {count} 条预警',
    later: '稍后处理',
    dismissSession: '本次登录不再提醒',
    viewDetail: '查看详情'
  },

  // 表单验证
  validation: {
    required: '此项为必填项',
    pattern: '格式不正确',
    maxLength: '长度不能超过 {max} 个字符',
    minLength: '长度不能少于 {min} 个字符',
    number: '请输入数字',
    integer: '请输入整数',
    positive: '请输入正数',
    nonNegative: '请输入非负数'
  }
}


